import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getUkDate } from '../utilities'

export interface sortType {
	type: string,
	reverse?: boolean
}
export interface getQuoteListState {
	id: string
}
export interface generateQuoteState {
	id: string,
	json: string
}
export interface acceptQuoteState {
	id: string,
	generated: string,
	accepted: string,
	instructed: string,
	schemeid: string,
	introducerid: string,
	developerid: string,
	siteid: string,
	mattertype: string,
	createdby: string,
	filename: string,
	quoteformdata: string,
	quotebreakdowndata: string,
	instructionformdata: string
}
export interface instructQuoteState {
	id: string,
	quoteformdata: string,
	quotebreakdowndata: string,
	instructionformdata: string
}
interface quoteCPDataState {
	InstructionGUI: string,
	InfoMoniesOnAccountReceivedDate: string,
	IntroducerVoucherTriggerDate: string,
	ClientCareCompleteDate: string,
}
export interface quoteListState {
	quoteid: string,
	type: string,
	name: string,
	nhgStaffName: string,
	consultant: string,
	site: string,
	developer: string,
	plsSalesStaff: string,
	cpData: quoteCPDataState,
	created: string,
	generated: string,
	accepted: string,
	instructed: string,
	visible: boolean,
}
export interface feeState {
	Code: string,
	Description: string,
	Quantity: number,
	Value: string
}
export interface quoteBreakdownState {
	Disbursements: feeState[],
	DisbursementsTotal: string,
	ExtraFees: feeState[],
	ExtraFeesTotal: string,
	PLSFee: string,
	IntroducerFee: string,
	Fees: string,
	FeesTotal: string,
	Total: string,
	Vat: string
}
export interface quoteState {
	quoteid: string,
	type: string,
	quoteformdata: string,
	quotebreakdowndata: string,
	instructionformdata: string,
	created: string,
	generated: string,
	accepted: string,
	instructed: string,
	quotebreakdown: quoteBreakdownState | null,
	isSaving: boolean,
	isGenerating: boolean,
	isEmailing: boolean,
	isAccepting: boolean,
	isInstructing: boolean
}
interface quotesState {
	sortType: sortType,
	searchStr: string,
	offset: string,
	quotes: quoteListState[],
	quote: quoteState,
	totalQuotes: number,
	rowsPerPage: number,
	skip: number,
}

const qo = {
	sortType: {
		type: 'Reference',
		reverse: false
	},
	searchStr: '',
	offset: '0%',
	quotes: [],
	quote: {
		quoteid: '',
		type: '',
		quoteformdata: '',
		quotebreakdowndata: '',
		instructionformdata: '',
		created: '1900-01-01 00:00:00.000',
		generated: '1900-01-01 00:00:00.000',
		accepted: '1900-01-01 00:00:00.000',
		instructed: '1900-01-01 00:00:00.000',
		quotebreakdown: {
			"Disbursements": [],
			"DisbursementsTotal": "",
			"ExtraFees": [],
			"ExtraFeesTotal": "",
			"PLSFee": "",
			"IntroducerFee": "",
			"Fees": "",
			"FeesTotal": "",
			"Total": "",
			"Vat": ""
		},
		isSaving: false,
		isGenerating: false,
		isEmailing: false,
		isAccepting: false,
		isInstructing: false
	},
	totalQuotes: 0,
	rowsPerPage: 50,
	skip: 0,
}
const initialState: quotesState = qo;

function compareReference(a: quoteListState, b: quoteListState) {
	if (a.quoteid < b.quoteid) {
		return -1;
	}
	if (a.quoteid > b.quoteid) {
		return 1;
	}
	return 0;
}
function compareType(a: quoteListState, b: quoteListState) {
	if (a.type < b.type) {
		return -1;
	}
	if (a.type > b.type) {
		return 1;
	}
	return 0;
}
function compareName(a: quoteListState, b: quoteListState) {
	if (a.name.trim() < b.name.trim()) {
		return -1;
	}
	if (a.name.trim() > b.name.trim()) {
		return 1;
	}
	return 0;
}
function compareNHGStaffName(a: quoteListState, b: quoteListState) {
	if (a.nhgStaffName.trim() < b.nhgStaffName.trim()) {
		return -1;
	}
	if (a.nhgStaffName.trim() > b.nhgStaffName.trim()) {
		return 1;
	}
	return 0;
}
function compareConsultant(a: quoteListState, b: quoteListState) {
	if (a.consultant.trim() < b.consultant.trim()) {
		return -1;
	}
	if (a.consultant.trim() > b.consultant.trim()) {
		return 1;
	}
	return 0;
}
function compareSite(a: quoteListState, b: quoteListState) {
	if (a.site.trim() < b.site.trim()) {
		return -1;
	}
	if (a.site.trim() > b.site.trim()) {
		return 1;
	}
	return 0;
}
function compareDeveloper(a: quoteListState, b: quoteListState) {
	if (a.developer.trim() < b.developer.trim()) {
		return -1;
	}
	if (a.developer.trim() > b.developer.trim()) {
		return 1;
	}
	return 0;
}
function comparePLSSalesStaff(a: quoteListState, b: quoteListState) {
	if (a.plsSalesStaff?.trim() < b.plsSalesStaff?.trim()) {
		return -1;
	}
	if (a.plsSalesStaff?.trim() > b.plsSalesStaff?.trim()) {
		return 1;
	}
	return 0;
}
function comapreSignedClientDocuments(a: quoteListState, b: quoteListState) {
	if (a.cpData.ClientCareCompleteDate?.trim() < b.cpData.ClientCareCompleteDate?.trim()) {
		return -1;
	}
	if (a.cpData.ClientCareCompleteDate?.trim() > b.cpData.ClientCareCompleteDate?.trim()) {
		return 1;
	}
	return 0;
}
function comapreMoniesOnAccount(a: quoteListState, b: quoteListState) {
	if (a.cpData.InfoMoniesOnAccountReceivedDate?.trim() < b.cpData.InfoMoniesOnAccountReceivedDate?.trim()) {
		return -1;
	}
	if (a.cpData.InfoMoniesOnAccountReceivedDate?.trim() > b.cpData.InfoMoniesOnAccountReceivedDate?.trim()) {
		return 1;
	}
	return 0;
}
function comapreVoucherDue(a: quoteListState, b: quoteListState) {
	if (a.cpData.IntroducerVoucherTriggerDate?.trim() < b.cpData.IntroducerVoucherTriggerDate?.trim()) {
		return -1;
	}
	if (a.cpData.IntroducerVoucherTriggerDate?.trim() > b.cpData.IntroducerVoucherTriggerDate?.trim()) {
		return 1;
	}
	return 0;
}
function compareCreated(a: quoteListState, b: quoteListState) {
	if (a.created < b.created) {
		return -1;
	}
	if (a.created > b.created) {
		return 1;
	}
	return 0;
}
function compareGenerated(a: quoteListState, b: quoteListState) {
	if (a.generated < b.generated) {
		return -1;
	}
	if (a.generated > b.generated) {
		return 1;
	}
	return 0;
}
function compareAccepted(a: quoteListState, b: quoteListState) {
	if (a.accepted < b.accepted) {
		return -1;
	}
	if (a.accepted > b.accepted) {
		return 1;
	}
	return 0;
}
function compareInstructed(a: quoteListState, b: quoteListState) {
	if (a.instructed < b.instructed) {
		return -1;
	}
	if (a.instructed > b.instructed) {
		return 1;
	}
	return 0;
}

export const getQuoteList = createAsyncThunk(
	'quotes/getquotelist',
	async (get: getQuoteListState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("id", get.id);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/loadquotes.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const getQuote = createAsyncThunk(
	'quotes/getquote',
	async (id: string, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", id);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/loadquote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const saveQuote = createAsyncThunk(
	'quotes/savequote',
	async (get: acceptQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append('Generated', get.generated);
			formdata.append('Accepted', get.accepted);
			formdata.append('Instructed', get.instructed);
			formdata.append('SchemeID', get.schemeid);
			formdata.append('IntroducerID', get.introducerid);
			formdata.append('DeveloperID', get.developerid);
			formdata.append('SiteID', get.siteid);
			formdata.append('MatterTypeDescription', get.mattertype);
			formdata.append('CreatedBy', get.createdby);
			formdata.append('Filename', get.filename);
			formdata.append('QuoteFormData', get.quoteformdata);
			formdata.append('QuoteBreakdownData', get.quotebreakdowndata);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/savequote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const generatePurchaseQuote = createAsyncThunk(
	'quotes/generatepurchasequote',
	async (get: generateQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append("QuoteFormData", get.json);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/Purchase/generatequote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const generateRemortgageQuote = createAsyncThunk(
	'quotes/generateremortgagequote',
	async (get: generateQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append("QuoteFormData", get.json);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/Remortgage/generatequote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const generateSaleQuote = createAsyncThunk(
	'quotes/generatesalequote',
	async (get: generateQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append("QuoteFormData", get.json);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/Sale/generatequote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const acceptQuote = createAsyncThunk(
	'quotes/acceptquote',
	async (get: acceptQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append('Generated', get.generated);
			formdata.append('Accepted', get.accepted);
			formdata.append('Instructed', get.instructed);
			formdata.append('SchemeID', get.schemeid);
			formdata.append('IntroducerID', get.introducerid);
			formdata.append('DeveloperID', get.developerid);
			formdata.append('SiteID', get.siteid);
			formdata.append('MatterTypeDescription', get.mattertype);
			formdata.append('CreatedBy', get.createdby);
			formdata.append('Filename', get.filename);
			formdata.append('QuoteFormData', get.quoteformdata);
			formdata.append('QuoteBreakdownData', get.quotebreakdowndata);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/acceptquote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const emailQuote = createAsyncThunk(
	'quotes/emailquote',
	async (get: acceptQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append('Generated', get.generated);
			formdata.append('Accepted', get.accepted);
			formdata.append('Instructed', get.instructed);
			formdata.append('SchemeID', get.schemeid);
			formdata.append('IntroducerID', get.introducerid);
			formdata.append('DeveloperID', get.developerid);
			formdata.append('SiteID', get.siteid);
			formdata.append('MatterTypeDescription', get.mattertype);
			formdata.append('CreatedBy', get.createdby);
			formdata.append('Filename', get.filename);
			formdata.append('QuoteFormData', get.quoteformdata);
			formdata.append('QuoteBreakdownData', get.quotebreakdowndata);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/emailquote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const instructPurchaseQuote = createAsyncThunk(
	'quotes/instructpurchasequote',
	async (get: instructQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append('QuoteFormData', get.quoteformdata);
			formdata.append('QuoteBreakdownData', get.quotebreakdowndata);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/Purchase/instructquote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const instructRemortgageQuote = createAsyncThunk(
	'quotes/instructremortgagequote',
	async (get: instructQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append('QuoteFormData', get.quoteformdata);
			formdata.append('QuoteBreakdownData', get.quotebreakdowndata);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/Remortgage/instructquote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const instructSaleQuote = createAsyncThunk(
	'quotes/instructsalequote',
	async (get: instructQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("QuoteID", get.id);
			formdata.append('QuoteFormData', get.quoteformdata);
			formdata.append('QuoteBreakdownData', get.quotebreakdowndata);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'quotes/Sale/instructquote.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const instructPurchase = createAsyncThunk(
	'quotes/instructpurchase',
	async (get: acceptQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append('SchemeID', get.schemeid);
			formdata.append('IntroducerID', get.introducerid);
			formdata.append('DeveloperID', get.developerid);
			formdata.append('SiteID', get.siteid);
			formdata.append('MatterTypeDescription', get.mattertype);
			formdata.append('CreatedBy', get.createdby);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'instructions/Purchase/instruct.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const instructRemortgage = createAsyncThunk(
	'quotes/instructremortgage',
	async (get: acceptQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append('SchemeID', get.schemeid);
			formdata.append('IntroducerID', get.introducerid);
			formdata.append('DeveloperID', get.developerid);
			formdata.append('SiteID', get.siteid);
			formdata.append('MatterTypeDescription', get.mattertype);
			formdata.append('CreatedBy', get.createdby);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'instructions/Remortgage/instruct.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const instructSale = createAsyncThunk(
	'quotes/instructsale',
	async (get: acceptQuoteState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append('SchemeID', get.schemeid);
			formdata.append('IntroducerID', get.introducerid);
			formdata.append('DeveloperID', get.developerid);
			formdata.append('SiteID', get.siteid);
			formdata.append('MatterTypeDescription', get.mattertype);
			formdata.append('CreatedBy', get.createdby);
			formdata.append('InstructionFormData', get.instructionformdata);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'instructions/Sale/instruct.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const quotesSlice = createSlice({
	name: 'quotes',
	initialState,
	reducers: {
		setsortType: (state: { sortType: { type: string; reverse?: boolean; }; quotes: any[]; }, action: PayloadAction<sortType>) => {
			if (typeof action.payload.reverse === 'undefined') {
				if (action.payload.type === state.sortType.type) {
					action.payload.reverse = !state.sortType.reverse;
				} else {
					action.payload.reverse = false;
				}
			}
			state.sortType = action.payload;
			switch (state.sortType.type) {
				case 'Reference':
					state.quotes.sort(compareReference);
					break;
				case 'Type':
					state.quotes.sort(compareType);
					break;
				case 'Name':
					state.quotes.sort(compareName);
					break;
				case 'NHGStaffName':
					state.quotes.sort(compareNHGStaffName);
					break;
				case 'Consultant':
					state.quotes.sort(compareConsultant);
					break;
				case 'Site':
					state.quotes.sort(compareSite);
					break;
				case 'Developer':
					state.quotes.sort(compareDeveloper);
					break;
				case 'PLSSalesStaff':
					state.quotes.sort(comparePLSSalesStaff);
					break;
				case 'SignedClientDocuments':
					state.quotes.sort(comapreSignedClientDocuments);
					break;
				case 'MoniesOnAccount':
					state.quotes.sort(comapreMoniesOnAccount);
					break;
				case 'VoucherDue':
					state.quotes.sort(comapreVoucherDue);
					break;
				case 'Created':
					state.quotes.sort(compareCreated);
					break;
				case 'Generated':
					state.quotes.sort(compareGenerated);
					break;
				case 'Accepted':
					state.quotes.sort(compareAccepted);
					break;
				case 'Instructed':
					state.quotes.sort(compareInstructed);
					break;
			}
			if (state.sortType.reverse) {
				state.quotes.reverse();
			}
		},
		searchQuotes: (state: quotesState, action: PayloadAction<string>) => {
			state.searchStr = action.payload;
			for (const c of state.quotes) {
				if (c.quoteid.includes(action.payload) || c.name.toLowerCase().includes(action.payload.toLowerCase()) || getUkDate(c.created).includes(action.payload) || (c.nhgStaffName.toLowerCase().includes(action.payload.toLowerCase()))) {
					c.visible = true;
				} else {
					c.visible = false;
				}
			}
		},
		setOffset: (state: quotesState, action: PayloadAction<string>) => {
			state.offset = action.payload;
		},
		selectQuote: (state: quotesState, action: PayloadAction<string>) => {
			state.quote.quoteid = action.payload;
			if (action.payload === "") {
				state.quote.type = "";
				state.quote.quoteformdata = "";
				state.quote.quotebreakdowndata = "";
				state.quote.instructionformdata = "";
				state.quote.created = "1900-01-01 00:00:00.000";
				state.quote.generated = "1900-01-01 00:00:00.000";
				state.quote.accepted = "1900-01-01 00:00:00.000";
				state.quote.instructed = "1900-01-01 00:00:00.000";
				state.quote.quotebreakdown = {
					"Disbursements": [],
					"DisbursementsTotal": '0.00',
					"ExtraFees": [],
					"ExtraFeesTotal": '0.00',
					"PLSFee": '0.00',
					"IntroducerFee": '0.00',
					"Fees": '0.00',
					"FeesTotal": '0.00',
					"Total": "",
					"Vat": '0.00'
				}
			}
		},
		setQuoteId: (state: quotesState, action: PayloadAction<string>) => {
			state.quote.quoteid = action.payload;
		},
		setQuoteType: (state: quotesState, action: PayloadAction<string>) => {
			state.quote.type = action.payload;
		},
		setQuoteFormData: (state: quotesState, action: PayloadAction<string>) => {
			state.quote.quoteformdata = action.payload;
		},
		setInstructionFormData: (state: quotesState, action: PayloadAction<string>) => {
			state.quote.instructionformdata = action.payload;
		},
		setSaving: (state: quotesState, action: PayloadAction<boolean>) => {
			state.quote.isSaving = action.payload;
		},
		setGenerating: (state: quotesState, action: PayloadAction<boolean>) => {
			state.quote.isGenerating = action.payload;
		},
		setEmailing: (state: quotesState, action: PayloadAction<boolean>) => {
			state.quote.isEmailing = action.payload;
		},
		setAccepting: (state: quotesState, action: PayloadAction<boolean>) => {
			state.quote.isAccepting = action.payload;
		},
		setInstructing: (state: quotesState, action: PayloadAction<boolean>) => {
			state.quote.isInstructing = action.payload;
		},
		setSkip: (state: quotesState, action: PayloadAction<string>) => {
			state.skip = Number(action.payload);
		},
		setRowsPerPage: (state: quotesState, action: PayloadAction<string>) => {
			state.rowsPerPage = Number(action.payload);
		},
	},
	extraReducers: (builder: { addCase: (arg0: any, arg1: { (state: any, action: any): void; (state: any, action: any): void; }) => void; }) => {
		builder.addCase(getQuoteList.fulfilled, (state: quotesState, action: { payload: string; }) => {
			try {
				const json = JSON.parse(action.payload as string);
				state.quotes = [];
				state.totalQuotes = json.quoteList.length;
				for (var i = 0; i < json.quoteList.length; i++) {
					const jq = json.quoteList[i];
					const fd = JSON.parse(jq.QuoteFormData);

					state.quotes.push({
						quoteid: jq.QuoteID,
						type: jq.MatterTypeDescription,
						created: jq.Created,
						generated: jq.Generated,
						accepted: jq.Accepted,
						instructed: jq.Instructed,
						name: fd.quote_first_name.val + ' ' + fd.quote_surname.val,
						nhgStaffName: fd?.staff_name_NHG?.val ?? ' ',
						consultant: fd?.staff_name_Leadersromansgroup?.val ?? ' ',
						site: fd?.site_name_Leadersromansgroup?.val ?? ' ',
						developer: fd?.developer_name_Leadersromansgroup?.val ?? ' ',
						plsSalesStaff: jq.AssignedTo,
						cpData: jq?.CPData,
						visible: true
					});
				}
				switch (state.sortType.type) {
					case 'Reference':
						state.quotes.sort(compareReference);
						break;
					case 'Type':
						state.quotes.sort(compareType);
						break;
					case 'Name':
						state.quotes.sort(compareName);
						break;
					case 'NHGStaffName':
						state.quotes.sort(compareNHGStaffName);
						break;
					case 'Consultant':
						state.quotes.sort(compareConsultant);
						break;
					case 'Site':
						state.quotes.sort(compareSite);
						break;
					case 'Developer':
						state.quotes.sort(compareDeveloper);
						break;
					case 'PLSSalesStaff':
						state.quotes.sort(comparePLSSalesStaff);
						break;
					case 'SignedClientDocuments':
						state.quotes.sort(comapreSignedClientDocuments);
						break;
					case 'MoniesOnAccount':
						state.quotes.sort(comapreMoniesOnAccount);
						break;
					case 'VoucherDue':
						state.quotes.sort(comapreVoucherDue);
						break;
					case 'Created':
						state.quotes.sort(compareCreated);
						break;
					case 'Generated':
						state.quotes.sort(compareGenerated);
						break;
					case 'Accepted':
						state.quotes.sort(compareAccepted);
						break;
					case 'Instructed':
						state.quotes.sort(compareInstructed);
						break;
				}
				if (state.sortType.reverse) {
					state.quotes.reverse();
				}
				for (const c of state.quotes) {
					if (c.quoteid.includes(state.searchStr) || c.name.toLowerCase().includes(state.searchStr.toLowerCase())) {
						c.visible = true;
					} else {
						c.visible = false;
					}
				}
			} catch (e) { }
		})
		builder.addCase(getQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.quoteid = json.quote.QuoteID;
				state.quote.type = json.quote.MatterTypeDescription;
				state.quote.quoteformdata = json.quote.QuoteFormData;
				state.quote.quotebreakdowndata = json.quote.QuoteBreakdownData;
				state.quote.instructionformdata = json.quote.InstructionFormData;
				state.quote.created = json.quote.Created;
				state.quote.generated = json.quote.Generated;
				state.quote.accepted = json.quote.Accepted;
				state.quote.instructed = json.quote.Instructed;
				try {
					state.quote.quotebreakdown = JSON.parse(state.quote.quotebreakdowndata);
				} catch (error) {
					console.error(error);
				}
			} catch (e) { }
		})
		builder.addCase(saveQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isSaving = false;
		})
		builder.addCase(generatePurchaseQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isGenerating = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.generated = json.Generated;
				state.quote.quotebreakdowndata = json.QuoteBreakdownData;
				state.quote.quotebreakdown = JSON.parse(state.quote.quotebreakdowndata);
			} catch (e) { }
		})
		builder.addCase(generateRemortgageQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isGenerating = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.generated = json.Generated;
				state.quote.quotebreakdowndata = json.QuoteBreakdownData;
				state.quote.quotebreakdown = JSON.parse(state.quote.quotebreakdowndata);
			} catch (e) { }
		})
		builder.addCase(generateSaleQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isGenerating = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.generated = json.Generated;
				state.quote.quotebreakdowndata = json.QuoteBreakdownData;
				state.quote.quotebreakdown = JSON.parse(state.quote.quotebreakdowndata);
			} catch (e) { }
		})
		builder.addCase(acceptQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isAccepting = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.accepted = json.quoteQuote.Accepted;
			} catch (e) { }
		})
		builder.addCase(emailQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isEmailing = false;
			try {
			} catch (e) { }
		})
		builder.addCase(instructPurchaseQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isInstructing = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.instructed = json.quoteQuote.Instructed;
			} catch (e) { }
		})
		builder.addCase(instructRemortgageQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isInstructing = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.instructed = json.quoteQuote.Instructed;
			} catch (e) { }
		})
		builder.addCase(instructSaleQuote.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isInstructing = false;
			try {
				const json = JSON.parse(action.payload as string);
				state.quote.instructed = json.quoteQuote.Instructed;
			} catch (e) { }
		})
		builder.addCase(instructPurchase.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isInstructing = false;
			try {
			} catch (e) { }
		})
		builder.addCase(instructRemortgage.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isInstructing = false;
			try {
			} catch (e) { }
		})
		builder.addCase(instructSale.fulfilled, (state: quotesState, action: { payload: string; }) => {
			state.quote.isInstructing = false;
			try {
			} catch (e) { }
		})
	}
})

export const { setsortType, searchQuotes, setOffset, selectQuote, setQuoteId, setQuoteType, setQuoteFormData, setInstructionFormData, setSaving, setGenerating, setEmailing, setAccepting, setInstructing,setSkip, setRowsPerPage } = quotesSlice.actions;
export default quotesSlice.reducer;